var a={tabs:"Tabs__tabs-aai",tab:"Tabs__tab-lAk",active:"Tabs__active-GK7"};export{a as default};
